import Vue from 'vue'
import Router from 'vue-router'
import Authorize from '@/components/Authorize'
import AskRoles from '@/components/AskRoles'
import AskPin from '@/components/AskPin'
import ChooseUsers from '@/components/ChooseUsers'
import QrCode from '@/components/QrCode'
import ResetPassword from '@/components/ResetPassword'
import NewPassword from '@/components/NewPassword'
import QrCodeRedirect from "@/components/QrCodeRedirect";
import Wallet from "@/components/Wallet";
import CreatePin from "@/components/CreatePin";
import Error from "@/components/Error";
import Success from "@/components/Success";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'AuthorizeHome',
      component: Authorize
    }, 
    {
      path: '/authorize',
      name: 'Authorize',
      component: Authorize
    },
    {
      path: '/ask-roles',
      name: 'AskRoles',
      component: AskRoles
    },
    {
      path: '/ask-pin',
      name: 'AskPin',
      component: AskPin
    },
    {
      path: '/choose-users',
      name: "ChooseUsers",
      component: ChooseUsers,
      props: true
    },
    {
      path: '/qr-code',
      name: "QrCode",
      component: QrCode,
    },
    {
      path:'/reset-password',
      name: "ResetPassword",
      component: ResetPassword
    },
    {
      path:'/new-password',
      name: "NewPassword",
      component: NewPassword
    },
    {
      path: '/qr',
      name: "QrCodeRedirect",
      component: QrCodeRedirect
    },
    {
      path: '/wallet',
      name: "Wallet",
      component: Wallet
    },
    {
      path: '/create-pin',
      name: "CreatePin",
      component: CreatePin
    },
    {
      path: '/error',
      name: "Error",
      component: Error
    }, 
    {
      path: '/success',
      name: "Success",
      component: Success
    }
  ]
})

function hasQueryParams(route) {
  return !!Object.keys(route.query).length;
}

router.beforeEach((to, from, next) => {
  if(!hasQueryParams(to) && hasQueryParams(from)) {
    next({path: to.path, query: from.query})
  } else {
    next()
  }  
});


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js